﻿let Q = require('q');
const enterKeyCode = 13;

module.exports = RegionSearchBox;

function RegionSearchBox({searchButton, queryInput, serverRoot, defaultUrl}) {
    searchButton.click(e => this.search(queryInput, serverRoot, defaultUrl));
    queryInput.keypress(e => {
        if (e.keyCode === enterKeyCode) {
            this.search(queryInput, serverRoot, defaultUrl);
        }
    });
}

RegionSearchBox.prototype = {
    search(queryInput, serverRoot, defaultUrl) {
        let searchPhrase = queryInput.val();
        this.findRegionByZipcode(searchPhrase, serverRoot)
            .then(region => region.PageUrl || defaultUrl, e => defaultUrl)
            .then(this.openRegionPage)
            .done();
    },

    findRegionByZipcode(zipcode, serverRoot) {
        return Q(
            jQuery.ajax({
                url: serverRoot + '/api/regions',
                data: {
                    zipcode: zipcode
                }
            })
        );
    },

    openRegionPage(url) {
        if(url) {
            window.location.href = url;
        } else {
            //TODO consider some kind of error handling
            console.log('Region could not be found');
        }
    }
}